import React from "react";

const CheckIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.127 0.850935C11.3933 1.10516 11.4032 1.52716 11.1489 1.79349L4.14892 9.12682C4.02498 9.25666 3.85392 9.33104 3.67444 9.33313C3.49495 9.33521 3.32221 9.26483 3.19528 9.13791L0.861949 6.80458C0.6016 6.54423 0.6016 6.12212 0.861949 5.86177C1.1223 5.60142 1.54441 5.60142 1.80476 5.86177L3.6556 7.71261L10.1845 0.872855C10.4387 0.606522 10.8607 0.596709 11.127 0.850935Z" fill="#2D2D2D" />
        </svg>
    )
}
export default CheckIcon;